export enum IntervalUnit {
  Minutes = 'minutes',
  Hours = 'hours',
  Days = 'days',
  Weeks = 'weeks',
  Months = 'months',
  Years = 'years',
}

export interface Interval {
  unit: IntervalUnit
  value: number
}

const UnitTable: Map<string, IntervalUnit> = new Map([
  ['minute', IntervalUnit.Minutes],
  ['minutes', IntervalUnit.Minutes],
  ['hour', IntervalUnit.Hours],
  ['hours', IntervalUnit.Hours],
  ['day', IntervalUnit.Days],
  ['days', IntervalUnit.Days],
  ['week', IntervalUnit.Weeks],
  ['weeks', IntervalUnit.Weeks],
  ['month', IntervalUnit.Months],
  ['months', IntervalUnit.Months],
  ['year', IntervalUnit.Years],
  ['years', IntervalUnit.Years],
])

const IntervalValues = {
  [IntervalUnit.Minutes]: 1,
  [IntervalUnit.Hours]: 2,
  [IntervalUnit.Days]: 3,
  [IntervalUnit.Weeks]: 4,
  [IntervalUnit.Months]: 5,
  [IntervalUnit.Years]: 6,
} as const

export function sortByIntervalAsc<T>(intervalExtractor: (item: T) => IntervalUnit) {
  return (a: T, b: T) => IntervalValues[intervalExtractor(a)] - IntervalValues[intervalExtractor(b)]
}

export function normalizeIntervalUnit(unit: string): IntervalUnit {
  const normalized = UnitTable.get(unit)
  if (normalized === undefined) {
    throw new Error(`invalid interval unit \`${unit}\``)
  }
  return normalized
}
